export default function noLinkHash(href) {
    return !href?.includes('#');
}
